import { buildLinkSettingsQuery, parseLinkOffKeys } from '../questionnaires/linkSettings';

// Waar een zuil (kioskmodus, `?variant=kiosk…`) na het einde van de vragenlijst
// naartoe gaat: terug naar de zuilpagina, met dezelfde link voor de volgende
// respondent. Dat is inclusief de instellingen die de deellink uitzet
// (`?uit=…`), anders krijgt de tweede respondent bijvoorbeeld de AI Interviewer
// terug. Gecodeerd in één segment, net zoals KioskLink de hele link meegeeft.

/**
 * @param {string} pathname - `window.location.pathname` van de vragenlijst
 * @param {string} search - `window.location.search` van de vragenlijst
 * @returns {string|null} De terugweg, of `null` buiten de kioskmodus
 */
const kioskReturnLink = (pathname, search) => {
    const variant = new URLSearchParams(search || '').get('variant') || '';
    if (!variant.includes('kiosk')) return null;

    const baseLink = variant === 'kiosk_boring'
        ? 'https://deccos-website.web.app/kiosklink2/'
        : 'https://deccos-website.web.app/kiosklink/';
    const settings = buildLinkSettingsQuery(parseLinkOffKeys(search));

    return `${baseLink}/${pathname}${settings ? encodeURIComponent(settings) : ''}`;
};

export default kioskReturnLink;
